import { endOfDay, isWithinInterval } from "date-fns";

type HolidayTheme = "halloween";

/** Holiday theme for the chat homepage, or `null` outside a holiday window. */
export const HOLIDAY_THEME: HolidayTheme | null = isWithinInterval(new Date(), {
  // Oct 30, 12:00 AM through Oct 31, 11:59 PM in the viewer's own timezone.
  start: new Date(2026, 9, 30),
  end: endOfDay(new Date(2026, 9, 31)),
})
  ? "halloween"
  : null;
